// extracted by mini-css-extract-plugin
export default {"root":"Banner_root__ZX8gx","indicators":"Banner_indicators__3W8rc","active":"Banner_active__0XhS7","content":"Banner_content__xrHZH"};